
import ExecutorTaskNotFoundSvgComponent from '../../assets/svg-components/not-found/executor-task';
import './index.scss';

export default function MappedCheckpointMasterNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          {/* <img
            src="/images/page-not-found/executor-task.svg"
            className="not-found-image img-fluid not-found-image-executor-task"
          /> */}
          <div className="not-found-image img-fluid not-found-image-executor-task">
            <ExecutorTaskNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text">No tasks found for selected timeframe or filters. Please change date or filter criteria to view information.</p>
        </div>
      </div>
    </>
  );
}
